import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=cf00da82&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&id=cf00da82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf00da82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VList,VListItem,VMenu,VTab})
